import React from "react";
import { Bar } from "react-chartjs-2";

const options = {
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
  title: {
    display: false,
    text: "TOTAL DE HORAS ESTIMADAS / TOTAL DE HORAS REALIZADAS",
    titleFontSize: 20,
  },
  legend: {
    position: "bottom",
  },
};

function ChartBar(props) {
  const { dataObject, colaborador } = props;
  let totalEstimado;
  let totalGasto;
  let dadosEixoX;

  const meses = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];

  if (colaborador) {
    totalEstimado = dataObject?.tempoEstimadoColaborador;
    totalGasto = dataObject?.tempoGastoColaborador;
    dadosEixoX = dataObject?.nomesProjetos;
  } else {
    totalEstimado = dataObject?.dataViewTempoEstimado;
    totalGasto = dataObject?.dataViewTempoGasto;
    dadosEixoX = meses;
  }

  const data = {
    labels: dadosEixoX,
    datasets: [
      {
        type: "bar",
        label: "Total de horas estimadas",
        backgroundColor: "#63ABFD",
        data: totalEstimado,
        borderColor: ["#165BAA"],
        borderWidth: 1,
      },
      {
        type: "bar",
        label: "Total de horas realizadas",
        backgroundColor: "#E697FF",
        data: totalGasto,
        borderColor: "#A155B9",
        borderWidth: 1,
      },
    ],
  };

  return <Bar height={150} width={465} options={options} data={data} />;
}

export default ChartBar;
